// extracted by mini-css-extract-plugin
export default {"container":"StartScreen_container__V+e1x","left":"StartScreen_left__FfjSn","logo":"StartScreen_logo__l6CF8","heart":"StartScreen_heart__EINkg","right":"StartScreen_right__I0kbB"};